import styled from 'styled-components';

export const ImageWrapper = styled.img`
    margin: 0 auto;
    max-width: 100vw;
    max-height: 100vh;
    width: 100%;
`;
